export default "<h3>Database Transformation Settings</h3>\n<app-api-gateway-settings></app-api-gateway-settings>\n"